import React, { createElement } from 'react';
import CheckboxGroup from '../colorful-checkbox/colorful-group';
import './index.scss';
const RadioGroup = props => {
    const radioRrops = {
        ...props,
        type: 'radio',
    };
    return createElement(CheckboxGroup, { ...radioRrops });
};
RadioGroup.displayName = 'ColorfulRadioGroup';
export default React.memo(RadioGroup);
